import { useEffect, useState } from 'react'
import shortid from 'shortid'

import { Props as CheckboxProps } from 'components/formElements/Checkbox'

import styles from './toggleSwitch.module.scss'

const ToggleSwitch = ({ id, label, onChange, checked, className = '', disabled }: CheckboxProps) => {
  const labelId = typeof label === 'string' ? label.toLocaleLowerCase().replace(/ /g, '-') : ''

  const [localId] = useState(id || labelId || shortid.generate())
  const [localChecked, setLocalChecked] = useState(checked)

  useEffect(() => {
    if (checked !== localChecked) setLocalChecked(checked)
  }, [checked])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalChecked(!localChecked)

    if (onChange) onChange(!localChecked, e)
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <input
        type="checkbox"
        id={localId}
        className={styles.checkbox}
        onChange={handleChange}
        disabled={disabled}
        checked={checked}
      />
      <label htmlFor={localId} className={styles.switch} />

      {!!label && <label htmlFor={localId}>{label}</label>}
    </div>
  )
}

export default ToggleSwitch
